// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option[data-v-4a6c3524]{margin-bottom:2px}.option .separator[data-v-4a6c3524]{margin-bottom:-4px}.option:hover .separator[data-v-4a6c3524]{display:none}", ""]);
// Exports
module.exports = exports;
